import { Dialog, DialogContent, DialogActions } from "@mui/material";

import { yupResolver } from "@hookform/resolvers/yup";

import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { CouponEditorView, couponSchema } from "./CouponEditorView";

import { CouponModel, useAddCoupon } from "../coupon";
import { DialogTitle, FormButton } from "../../../atoms";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";

export const AddCouponModal = () => {
  const form = useForm<CouponModel>({
    resolver: yupResolver(couponSchema),
    defaultValues: {
      type: "",
      merchants: [],
      users: [],
      startDate: new Date().toISOString(),
      expiryDate: new Date().toISOString(),
      maximumCap: 0,
      minimumCap: 0,
      totalUsage: 0,
      usagePerUser: 0,
    },
  });
  const { mutate: addCoupon, isLoading } = useAddCoupon();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const handleClose = () => {
    navigate("..");
  };

  const onSubmit = (e: CouponModel) => {
    addCoupon(e, {
      onSuccess: () => {
        toast.success("Coupon added successfully.");
        queryClient.invalidateQueries("coupons");
        handleClose();
      },
    });
  };
  return (
    <Dialog maxWidth={"sm"} open>
      <DialogTitle title="Add New Coupon" handleClose={handleClose} />
      <DialogContent>
        <CouponEditorView form={form} />
      </DialogContent>
      <DialogActions>
        <FormButton disabled={!form.formState.isValid} loading={isLoading} fullWidth onClick={form.handleSubmit(onSubmit)} type="submit" label="Add Coupon"></FormButton>
      </DialogActions>
    </Dialog>
  );
};
